import React from "react";
import PropTypes from "prop-types";
import styles from "./SettingsField.module.css";

/**
 * A labelled input used throughout Settings. Outside of edit mode it renders a
 * read-only boxed value; in edit mode it becomes an editable input.
 */
export function SettingsField({
  label,
  value,
  onChange,
  editing = false,
  type = "text",
  placeholder = "",
  ariaLabel,
  min,
  max,
}) {
  return (
    <label className={styles.field}>
      {label && <span className={styles.label}>{label}</span>}
      <input
        className={`${styles.input} ${editing ? styles.editing : ""}`}
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        readOnly={!editing}
        min={min}
        max={max}
        aria-label={ariaLabel || label}
        onChange={(event) => onChange?.(event.target.value)}
      />
    </label>
  );
}

SettingsField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
